// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import Vant from 'vant';
import 'vant/lib/index.css';
import router from "./router"
import axios from "./config/httpConfig/http"
import Vueaxios from "vue-axios"
import doRequest from "./mixins/do_request"
Vue.use(Vant);
Vue.use(Vueaxios, axios)
Vue.mixin(doRequest)
Vue.config.productionTip = true
Vue.config.ignoredElements = ['wx-open-launch-weapp']
new Vue({
  router,

  render: h => h(App)
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js